import { gql } from "graphql-tag";

export const documentQuery = gql`
  query DocumentDetails($id: String!) {
    document(id: $id) {
      id
      category
      name
      uploadedAt
      downloadUrl
      type
      url
    }
  }
`;
